const RESOURCE_NAME = '/units-hw-types';
import restApi from "@/api/rest-api-object";

export default axios => ({
	...restApi(axios, RESOURCE_NAME),
	getTypes(hw_type, params) {
		return axios.get(`${RESOURCE_NAME}/${hw_type}/types`, {params});
	},
	getAttrs(hw_type, params) {
		return axios.get(`${RESOURCE_NAME}/${hw_type}/attrs`, {params});
	}
});